import type { Message } from '@/common/db-typebox/chat.typebox';
import { Skeleton } from 'antd';
import { useRef } from 'react';
import { ExampleCard } from './ExampleCard';
import { MessageContent } from './message-content';

interface MessageListProps {
  messages: Message[];
  isLoading: boolean;
  onError: (error: string | null) => void;
}

function MessageSkeleton() {
  return (
    <div className="space-y-4">
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={`message-skeleton-${i}-${Date.now()}`}
          className="flex justify-start"
        >
          <div className="max-w-[80%] rounded-2xl px-4 py-2">
            <Skeleton active paragraph={{ rows: 2, width: ['80%', '60%'] }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function MessageList({
  messages,
  isLoading,
  onError,
}: MessageListProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // const scrollToBottom = useCallback(() => {
  //   messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  // }, []);

  // useEffect(() => {
  //   if (messages?.length) {
  //     scrollToBottom();
  //   }
  // }, [messages, scrollToBottom]);

  return (
    <div className="flex-1 mb-4">
      <div className="space-y-4">
        <ExampleCard />
        {(messages ?? []).map((message) => (
          <MessageContent
            key={message.id}
            message={message}
            messages={messages}
            onError={onError}
          />
        ))}
        {isLoading && <MessageSkeleton />}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
}
